import { FormState } from '../../types';

export const BOOKING_TITLE = 'Get in touch';
export const BOOKING_SUBTITLE =
    'No matter where you are in your process, we have an AI Video Director ready to turn your vision into a finished, high-value production.\n\nSimply submit your details, and our AI video experts will get back to you promptly.\n\nYou can also reach us at';
export const BOOKING_EMAIL = 'ai-video-directors@fiverr.com';
export const BOOKING_DIRECTOR_HINT =
    "If you choose not to select a director, we'll match you with one who aligns with your needs.";

export const INITIAL_FORM_STATE: FormState = {
    fullName: '',
    budget: '',
    email: '',
    directorId: '',
    projectDescription: '',
};
